import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
})
export class SearchComponent {
  @Input() searchText = '';
  @Output() searchChange: EventEmitter<string> = new EventEmitter();
  @Input() placeholder = '';

  private debounceTimer: any;

  toggleSearch() {
    this.searchChange.emit(this.searchText);
    clearTimeout(this.debounceTimer);
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      clearTimeout(this.debounceTimer);
      this.searchChange.emit(this.searchText);
    }
  }

  handleInputChange(value: string): void {
    this.searchText = value;
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.searchChange.emit(this.searchText);
    }, 1000);
  }
}
